import type { FC } from "react";
import { useMemo } from "react";

import styles from "./SpinningNumber.module.scss";

type SpinningNumberProps = {
  number: number;
  textClassName?: string;
};

const ARRAY_OF_NUMBERS_FOR_ZERO_ANIMATION = [0, 3, 2, 1, 0];

const getArrayOfNumbers = (count: number): Array<number> => {
  if (count === 0) {
    return ARRAY_OF_NUMBERS_FOR_ZERO_ANIMATION;
  }
  return Array.from({ length: count + 1 }, (_, i) => i).reverse();
};

export const SpinningNumber: FC<SpinningNumberProps> = ({ number, textClassName }) => {
  const numbersArray = useMemo(() => {
    return getArrayOfNumbers(number);
  }, [number]);

  return (
    <div className={styles.numberContainer} data-number={number} data-testid="spinningNumber">
      {numbersArray.map((item) => (
        <span key={item} className={textClassName}>
          {item}
        </span>
      ))}
    </div>
  );
};
